const posts = {
    amathematicalidentitycrisis: {
        key: "amathematicalidentitycrisis",
        date: "03/27/2021",
        image: "https://i.ibb.co/PxfVBTZ/math.jpg",
        title: "a mathematical identity (crisis).",
        path: "/journal/amathematicalidentitycrisis",
        excerpt: "perhaps she is best defined as one that is constantly evolving, perpetually shifting – metamorphosing a multitude of times to converge towards who she is meant to be.",
    },
    daylight: {
        key: "daylight",
        date: "02/05/2021",
        image: "https://i.ibb.co/4t53wXz/daylight.jpg",
        title: "daylight /",
        path: "/journal/daylight",
        excerpt: "What does strength mean to you? She asks and I respond: daylight.",
    },
    reopening1: {
        key: "reopening1",
        date: "06/22/2021",
        image: "https://i.ibb.co/7tLbsD5/stage1reopening.jpg",
        title: ":stage 1 reopening.",
        path: "/journal/reopening1",
        excerpt: "When was the last time you felt inspired and reinvigorated from the physical space around you?",
    },
    twenty: {
        key: "twenty",
        date: "07/31/2021",
        image: "https://i.ibb.co/cJShJRL/20thbday.jpg",
        title: "20th birthday.",
        path: "/journal/twenty",
        excerpt: "May I gather the courage to grow, along a path where confidence blossom forth like wildflowers and healing pours in like the daylight. ",
    },
    torontotrip1: {
        key: "torontotrip1",
        date: "08/31/2021",
        image: "https://i.ibb.co/kHKZcKh/toronto2.jpg",
        title: ":end-of-summer toronto trip.",
        path: "/journal/torontotrip1",
        excerpt: "Miscellaneous accidents and serendipities unfold as though they have been predestined in the plotline, yet this spontaneity is at the very soul of adventure.",
    },
    reopening2: {
        key: "reopening2",
        date: "09/10/2021",
        image: "https://i.ibb.co/d2bYShc/ago.jpg",
        title: ":stage 2 reopening /",
        path: "/journal/reopening2",
        excerpt: "here comes the first time after a long time.",
    },
    pastimes: {
        key: "pastimes",
        date: "10/22/2021",
        image: "https://i.ibb.co/2KZjfx9/e4af9a39-5eda-4a99-8a6a-1568d99de602.jpg",
        title: "go where you encounter peace.",
        path: "/journal/pastimes",
        excerpt: "For a brief moment, I begin to wonder if I have been neglecting what's more meaningful to me to gather dust on the back shelf of my to-do list instead.",
    },
    idontwanttobeanyoneelsebutmyselfanymore: {
        key: "idontwanttobeanyoneelsebutmyselfanymore",
        date: "09/20/2021",
        image: "https://i.ibb.co/bRbS8RT/IMG-20210924-181601.jpg",
        title: "i don't want to be anyone else but myself anymore.",
        path: "/journal/idontwanttobeanyoneelsebutmyselfanymore",
        excerpt: "how I long to re-awaken and come vividly alive to this ordinary and unprecedented life — to the unique array of things that contain meaning to me.",
    },
    asurvivalguidefortheseason: {
        key: "asurvivalguidefortheseason",
        date: "11/05/2021",
        image: "https://i.ibb.co/wdsyQ2f/winter.jpg",
        title: "a survival guide for the season.",
        path: "/journal/asurvivalguidefortheseason",
        excerpt: "As the invincibility of sunlight fade to unveil the vulnerability of the cold, the change in the season comes as a reminder for a return towards a steadier rhythm and a recultivation of margins.",
    },
    beingbelonging: {
        key: "beingbelonging",
        date: "11/16/2021",
        image: "https://i.ibb.co/3C1D0X9/portrait.jpg",
        title: "to be & to belong.",
        path: "/journal/beingbelonging",
        excerpt: "I want to stand alongside you and feel empathy pulsing through us. I want to hold space for your story and be left in awe by how wildly different and terrifyingly similar that we are.",
    },
    founddocumentary: {
        key: "founddocumentary",
        date: "12/3/2021",
        image: "https://i.ibb.co/dLX8SCg/20200512232240.jpg",
        title: "[found]",
        path: "/journal/founddocumentary",
        excerpt: "'When you are listening to other people's stories, I think you can understand a lot of things [...] that you never know you would understand before.'"
    },
    indigo: {
        key: "indigo",
        date: "12/20/2021",
        image: "https://i.ibb.co/F33RN7y/20210703233201.jpg",
        title: "indigo. (a musing on vocation)",
        path: "/journal/indigo",
        excerpt: "What if my saturation of indigo only remains as dull, because I am capable of coming alive with unmatched vibrancy and sincerity, in entirely another color instead?"
    },
    twentytwentyone: {
        key: "twentytwentyone",
        date: "12/30/2021",
        image: "https://i.ibb.co/JvwGjh1/IMG-20211225-131616.jpg",
        path: "/journal/2021",
        title: "a letter of acknowledgment from 2021.",
        excerpt: "I’m thankful for all the strength that I have encountered in unexpected places, for each fragment of warmth ever extended to me, for all the courage that I’ve gathered like a bouquet of wildflowers to carry alongside with me for the rest of the journey."
    }
}

export default posts;